import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PrimitiveProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import type { BadgeVariants } from "."
import { reactiveOmit } from "@vueuse/core"
import { Primitive } from "reka-ui"
import { cn } from "@/lib/utils"
import { badgeVariants } from "."


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    asChild: { type: Boolean },
    as: {},
    variant: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), _mergeProps({
    "data-slot": "badge",
    class: _unref(cn)(_unref(badgeVariants)({ variant: __props.variant }), props.class)
  }, _unref(delegatedProps)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})